export default "__VITE_ASSET__BQvP0T5G__"